import React from "react";

/**
 * Public deep link handler for Android App Links verification.
 * This page is accessible without authentication to satisfy Google Play's
 * domain verification requirements.
 */
const DeepLinkHandler = () => {
    return <div></div>;
};

export default DeepLinkHandler;
